/**
 * How many bulk actions fit in the bar before the rest fold into a "…" menu.
 *
 * All of them when they fit as they are. Otherwise as many as fit beside the "…" button — the menu
 * needs its own room, so folding just the last action can mean folding the two last ones.
 */
export const visibleActionCount = (widths: number[], available: number, gap: number, moreButtonWidth: number): number => {
  const total = widths.reduce((sum, width, i) => sum + width + (i > 0 ? gap : 0), 0);
  if (total <= available) return widths.length;

  let used = moreButtonWidth;
  let count = 0;
  for (const width of widths) {
    const next = used + gap + width;
    if (next > available) break;
    used = next;
    count += 1;
  }
  return count;
};
